import {UsuarioInfoNavLink} from '@components/contas/UsuarioInformacao.tsx';
import {DefaultInformationProps} from '@models/DefaultProps.ts';
import {ILog} from '@models/seguranca/ILog.ts';
import {Grid, TableCell, TableRow} from '@mui/material';
import {ToDateDefault, ToDateString} from '@shared/MathHelp.ts';
import React, {useEffect, useState} from 'react';
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";

export interface LogInformationProps extends DefaultInformationProps<ILog> {
    variant: 'list' | 'row';
}

export const LogInformation: React.FC<LogInformationProps> = (props) => {
    const {variant} = props;
    if (variant === 'list')
        return <LogInformationList {...props} />;
    if (variant === 'row')
        return <LogInformationRow {...props} />;
};

export const LogInformationList: React.FC<Omit<LogInformationProps, 'variant' | 'overrides'>> = (props) => {
    const {value} = props;
    return (
        <Grid size={12}>
            <Grid></Grid>
            <Grid>{ToDateDefault(value.dataLog)}</Grid>

        </Grid>
    );
};

export const LogInformationRow: React.FC<Omit<LogInformationProps, 'variant' | 'overrides'>> = (props) => {
    const {value} = props;
    const {getUsuarios} = useUsuario()
    const [usuario, setUsuario] = useState<IUsuario | undefined>()

    useEffect(() => {
        if (value.usuarioOrigem != null) {
            setUsuario(value.usuarioOrigem)
            return
        }

        getUsuarios({id: [value.usuarioOrigemId]}, {page: 1, pageSize: 10}).then(x => {
            if (x.hasData) {
                setUsuario(x.items[0])
            } else {
                setUsuario(undefined)
            }
        })

    }, [value]);


    return (usuario != null && <TableRow>
        <TableCell><UsuarioInfoNavLink value={usuario} slotProps={{chip: {tableMode: true}}}/></TableCell>
        <TableCell>{ToDateString(value.dataLog, 'DD/MM/YYYY HH:mm')}</TableCell>
        <TableCell sx={{whiteSpace: 'nowrap'}}>{value.detalhes}</TableCell>
        <TableCell sx={{whiteSpace: 'nowrap'}}>{value.json}</TableCell>

    </TableRow>);
};